module.exports = __webpack_public_path__ + "static/media/Illus-Employee_2.d9242110.png";